<template>
  <custom-callout
    :has-toggle="false"
    :has-border="false"
    class="mb-3"
    :controlled="true"
  >
    <div class="row m-0 d-flex align-items-center py-2">
      <div class="col-md-2 col-12 mb-lg-0 border-right">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Título del Libro:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.name | empty }}
        </div>
      </div>
      <div class="col-md-2 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Materia:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.subject.name | empty }}
        </div>
      </div>
      <div class="col-md-2 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Grado:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.grade | empty }}
        </div>
      </div>
      <div class="col-md-2 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Casa Editorial:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.publisher | empty }}
        </div>
      </div>
      <div class="col-md-2 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Autor:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.author | empty }}
        </div>
      </div>
      <div class="col">
        <action-button
          id="btnSelect"
          :disabled="this.item.disabled"
          i="fas fa-times-circle"
          :class="'float-md-right mr-2'"
          variant="outline-danger"
          @click="removeOrder()"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import alertMixin from "@/mixin/alert.mixin";

export default {
  name: "ResultRowSelected",
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    }
  },
  methods: {
    async removeOrder() {
      let confirmDeletion = await this.ShowCancelModal(
        "Atención",
        `¿Está seguro que desea eliminar esta selección?`,
        "Si",
        "No"
      );

      if (!confirmDeletion) return;

      const {} = await inventoryOrderBooksService
        .removeOrder(this.item.id)
        .catch(() => {
          this.ShowToast(
            "Error",
            "Ha ocurrido un error al guardar la solicitud.",
            "error"
          );
        });

      this.ShowToast(
        "Proceso exitoso.",
        "El registro se ha eliminado correctamente.",
        "success"
      );

      this.$emit("refresh");
    }
  }
};
</script>
<style scoped lang="scss">
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

::v-deep .ab-btn-success {
  color: map.get($colors, "white") !important;
  background-color: map.get($colors, "green") !important;
  border-color: map.get($colors, "green") !important;
}
::v-deep .autocomplete-result-list {
  z-index: 2 !important;
}

::v-deep .ab-btn-outline-disabled {
  color: #b5c3bc !important;
  background-color: #fff !important;
  border-color: #b5c3bc !important;
}

::v-deep .text-disabled {
  color: #b5c3bc !important;
}
.border-left-4 {
  border-left: 4px solid #b5c3bc !important;
}
</style>
